import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import axios from "axios";
import DateBox from 'devextreme-react/date-box';
import { alert } from "devextreme/ui/dialog";
import DataSource from "devextreme/data/data_source";
import { SelectBox } from 'devextreme-react/select-box';
import { LocationPickMethodOptions, LotPickMethodOptions, SortDirectionOptions, SublotPickMethodOptions } from "../../../../../enum/TransactionDataEntryEnum";
import { NumberBox } from "devextreme-react";

function AutoSelectSublotScreen(props) {
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);

    const position = { of: "#accordion-containe2" };
    const handleFieldChange = (fieldName) => (e) => {
        if (fieldName === "ActualQuantity" && e.value > 0) {
            props.setPickMethods(prev => ({
                ...prev,
                ActualQuantity: e.value,
                QuantityOrdered: e.value,
                OriginalQuantityOrder: e.value
            }));
        }
        else {
            props.setPickMethods(prev => ({
                ...prev,
                [fieldName]: e.value
            }));
        }
    };
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);

    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <span>
                This method allows you to automatically select
                Sublots based on the criteria in the selection
                methods shown below.
            </span>
            <fieldset className='col-fieldset mt-2' >
                <legend className="list-title" >Sublot Selection For Shipment</legend>
                <div className="formfield-mb-2">
                    <SelectBox
                        onValueChanged={handleFieldChange('SublotPickMethod')}
                        dataSource={SublotPickMethodOptions}
                        value={props.pickMethods.SublotPickMethod}
                        displayExpr="name"
                        valueExpr="id"
                        labelMode='static'
                        stylingMode='outlined'
                        label="Pick Method"
                    />

                </div>

                <div >
                    <SelectBox
                        onValueChanged={handleFieldChange('SublotPickSeqMethod')}
                        dataSource={SortDirectionOptions}
                        value={props.pickMethods.SublotPickSeqMethod}
                        displayExpr="name"
                        valueExpr="id"
                        className="mt-2"
                        labelMode='static'
                        stylingMode='outlined'
                        label="Pick Seq"
                    />
                </div>
            </fieldset>
            <fieldset className='col-fieldset mt-2' >
                <legend className="list-title" >Location Selection For Shipment</legend>
                <div className="formfield-mb-2">
                    <SelectBox
                        onValueChanged={handleFieldChange('LocationPickMethod')}
                        dataSource={LocationPickMethodOptions}
                        value={props.pickMethods.LocationPickMethod}
                        displayExpr="name"
                        valueExpr="id"
                        className="mt-2"
                        labelMode='static'
                        stylingMode='outlined'
                        label="Pick Method"
                    />
                </div>

                <div>
                    <SelectBox
                        onValueChanged={handleFieldChange('LocationPickSeqMethod')}
                        dataSource={SortDirectionOptions}
                        value={props.pickMethods.LocationPickSeqMethod}
                        displayExpr="name"
                        valueExpr="id"
                        className="mt-2"
                        labelMode='static'
                        stylingMode='outlined'
                        label="Pick Seq"
                    />
                </div>
            </fieldset>
            <fieldset className='col-fieldset mt-2' >
                <div >
                    <NumberBox
                        onValueChanged={handleFieldChange('ActualQuantity')}
                        format="#,##0.00"
                        className="mt-2"
                        labelMode='static'
                        stylingMode='outlined'
                        label="Quantity"
                    />
                </div>
            </fieldset>
            <div className="center-button">
                <Button className="mt-2" text="Ok" type="default" style={{ marginRight: '10px' }} onClick={props.autoSelectLotScreenSubmit} />
                <Button className="mt-2" text="Cancel" onClick={props.autoSelectLotScreenClose} />
            </div>
        </div >
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AutoSelectSublotScreen);
